export const greater = (dateString: string, targetDateStr: string) => {
    const targetDate = new Date(targetDateStr);
    const parts = dateString.split('-')
    const date = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));

    return date > targetDate;
}